<div class="list-group list-group-flush border-bottom scrollarea">
<a *ngFor="let visit of visits" (click)="setActive(visit.getID())" [ngClass]="{'active': visit.getID()===selectedVisitID}" class="pe-pointer list-group-item list-group-item-action py-2 mb-0 lh-tight rounded-2" aria-current="true">
    <div class="d-flex w-100 align-items-center justify-content-between">
    {{visit.getDate().toLocaleString(langService.getLang(), { weekday: 'short'})}} {{visit.getDate().toLocaleTimeString(langService.getLang())}}
    <small>{{visit.getDate().toLocaleDateString(langService.getLang())}}</small>
    </div>
</a>

</div>